'use strict';

module.exports = require('../5/CheckObjectCoercible');



//////////////////
// WEBPACK FOOTER
// ./~/object.entries/~/es-abstract/2020/RequireObjectCoercible.js
// module id = 2670
// module chunks = 0